<template>
    <div class="vsebina ">

        <div class="glava_vsebine adapt v-adapt">

            <div class="cols">
                <div class="col left grid-col-6">
                    <h1>Proizvodi</h1>
                </div>



                <div class="col right">
                </div>

            </div>
        </div>

        <div class="telo_vsebine adapt v-adapt">
            <div>
                <div :style="{ display: 'inline-block' }">
                    Sezona
                    <br />
                    <dropdownlist :data-items="sezoneBranje" :text-field="'sezona'" @change="sezonaChange"
                        :value="dataSezona" />

                </div>
            </div>

            <div class="uporabnik-spacer" style="margin-top:2rem"></div>
            <div class="columnBar">
                <kendo-multiselect :data-source="columns" :data-text-field="'title'" :data-value-field="'field'"
                    :placeholder="'Skrij stolpce'" @select="skrijStolpec" @deselect="prikaziStolpec"
                    :filter="'contains'" :auto-width="true" :value="hiddenColumns">
                </kendo-multiselect>
            </div>
            <div class="grid-wrapper">
                <Grid :sortable="sortable" :filterable="filterable" :pageable="pageable" :data-items="dataResult"
                    :skip="skip" :take="take" :sort="sort" :resizable="true" @columnresize="columnresize"
                    :filter="filter" :columns="columns" @datastatechange="dataStateChange"
                    @pagechange="pageChangeHandler">

                    <template v-slot:nogaStMidov="{ props }">
                        <span>{{ nogaStMidov() }}</span>
                    </template>
                    <template v-slot:nogaVsotaKolicina="{ props }">
                        <span>{{ nogaVsotaKolicina() }}</span>
                    </template>
                    <toolbar>

                        <div class="km-widget km-buttongroup k-widget k-button-group">
                            <button title="Išči" class="k-button k-primary" @click="naloziPodatke">
                                Išči
                            </button>
                            <button title="Export to Excel" class="k-button k-primary" @click="exportExcel">
                                Izvozi v Excel
                            </button>
                        </div>

                    </toolbar>
                </Grid>
                <div class="shema-loader" v-if="loading"><font-awesome-icon icon="circle-notch" spin="spin" /></div>
            </div>
        </div>
    </div>

</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Dialog, DialogActionsBar } from '@progress/kendo-vue-dialogs';
//import '@progress/kendo-ui' // This will import the entire Kendo UI library
import '@progress/kendo-theme-default/dist/all.css'
import Vue from 'vue';
import { Grid, GridToolbar } from '@progress/kendo-vue-grid';
import { DropDownList } from '@progress/kendo-vue-dropdowns';
import { saveExcel } from '@progress/kendo-vue-excel-export';
import { MultiSelect } from '@progress/kendo-dropdowns-vue-wrapper';
Vue.component('kendo-multiselect', MultiSelect);


import { process } from '@progress/kendo-data-query';





Vue.component('Grid', Grid);
Vue.component('toolbar', GridToolbar);
Vue.component('dropdownlist', DropDownList);



export default {
    props: ['sezona'],
    data() {
        return {

            dataSezona: this.sezona,

            loading: false,


            filter: null,
            editID: null,
            skip: 0,
            take: 50,
            pageSize: 50,
            sortable: true,
            filterable: true,
            groupable: false,
            dataResult: [],
            columns: [

                { field: "kmgmid", title: "KMG-MID", width: "210px", footerCell: 'nogaStMidov'  },
                { field: "kontrolnastevilka", title: "Kont. št.", width: "100px"},
                { field: "imenosilca", title: "Nosilec", width: "150px" },
                { field: "naziv", title: "Proizvod" },
                { field: "skupinaproizvoda", title: "Skupina proizvoda" },
                { field: "vrstaproizvoda", title: "Vrsta proizvoda" },
                { field: "kolicina", title: "Količina", width: "100px", filterable: false, type: "number", footerCell: 'nogaVsotaKolicina', width: "100px", format: '{0:n2}' },
                { field: "merskaenotanaziv", title: "Enota", width: "80px", filterable: false },
                //{ field: "enota", title:"Enota", type:"string",filterable:false,width: "80px"},
                { field: "veljavnostcertifikataod", filterable: false, title: "Dat. dol. statusa", width: "120px", type: "date", format: "{0:d}" },
                //template: "#= kendo.toString(kendo.parseDate(veljavnostcertifikataod, 'yyyy-MM-dd'), 'MM/dd/yyyy') #"},
                //filter:'date',format: "{0:d}"},
                // { field: "veljavnostcertifikatado", title:"Veljavnost statusa", type:"string",editor: 'date',width: "150px",format: '{0:d}'},

                { field: "statuspridelkanaziv", title: "Status", width: "150px" },


                { field: "statuspridelovalca", title: "Status KMG", width: "150px", hidden: true },

                { field: "postnastevilka", title: "Poštna številka" },
                { field: "posta", title: "Pošta" },
                { field: "obcina", title: "Občina" },
                { field: "statisticnaregija", title: "Statistična regija" },
                { field: "kontrolnaorganizacija", title: "V kontroli pri" },
                { field: "naslovnosilca", title: "Naslov nosilca" },
                { field: "postnastevilkanosilca", title: "Poštna številka nosilca" },
                { field: "postanosilca", title: "Pošta nosilca" },
            ],
            sort: [
                //{ field: 'vrstakulture', dir: 'asc' }
            ],





        }
    },
    created() {




        if (!this.sezona)
            this.dataSezona = { sezona: Math.max(...this.sezoneBranje.map(s => s.sezona)) };
        else
            this.dataSezona = { sezona: this.sezona };
        //this.loadVse({sezona:this.dataSezona.sezona});
        this.getState()
    },
    beforeRouteLeave(to, from, next) {
        console.log("SHRANIM STANJE!");
        this.saveState();
        next()


    },
    computed: {
        pageable() {
            return { buttonCount: 3, pageSizes: [50, 100, this.gridData?.length] }
        },
        hiddenColumns() {
            return this.columns.filter(c => c.hidden);
        },


        ...mapState('users', ['userDetails', 'sezoneBranje']),
        ...mapState({
            gridData(state) {

                return state.proizvod.proizvod;
            }
        }),

    },
    watch: {
        skip(newValue, oldValue) {
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            };
            this.dataResult = process(this.gridData, dataState);
        },
        take(newValue, oldValue) {
            console.log(`Updating from ${oldValue} to ${newValue}`);

            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            }
            this.dataResult = process(this.gridData, dataState);
        },
        gridData(newValue, oldValue) {


            if (newValue) {
                const dataState = {
                    skip: this.skip,
                    take: this.take,
                    sort: this.sort,
                    filter: this.filter,
                    group: this.group
                };
                this.dataResult = process(this.gridData, dataState);

            }
        }
    },
    methods: {
        saveState: function () {
            const gridState = {};
            //gridState.data = [...this.gridData];
            gridState.sortable = this.sortable;
            gridState.filterable = this.filterable;
            gridState.groupable = this.groupable;
            gridState.skip = this.skip;
            gridState.take = this.take;
            gridState.group = this.group;
            gridState.sort = this.sort;
            gridState.filter = this.filter;
            gridState.columns = this.columns;
            gridState.sezona = this.dataSezona;

            localStorage.setItem('proizvodiState' + this.$version, JSON.stringify(gridState));
        },
        getState: function () {
            const gridState = JSON.parse(localStorage.getItem('proizvodiState' + this.$version));

            if (gridState !== null) {
                //this.gridData = gridState.data;
                this.sortable = gridState.sortable;
                this.filterable = gridState.filterable;
                this.groupable = gridState.groupable;
                this.skip = gridState.skip;
                this.take = gridState.take;
                this.group = gridState.group;
                this.sort = gridState.sort;
                this.filter = gridState.filter;
                this.columns = gridState.columns;
                this.dataSezona = gridState.sezona;
                this.dataResult = process(this.gridData, {
                    skip: this.skip,
                    take: this.take,
                    sort: this.sort,
                    filter: this.filter,
                    group: this.group,
                });
            }
        },
        columnresize: function (e) {
            if (e.end) {
                let column = e.columns[e.index];
                let sc = this.columns.find(c => c.field == column.field)

                sc.width = e.newWidth;

            }
        },
        ...mapActions('proizvod', ['loadVse']),
        naloziPodatke: async function (e) {
            this.loading = true;
            if (!this.sezona) {
                this.dataSezona = { sezona: Math.max(...this.sezoneBranje.map(s => s.sezona)) };
                this.sezona = this.dataSezona.sezona;
            }
            else
                this.dataSezona = { sezona: this.sezona };
            this.loadVse(this.dataSezona).then(() => this.loading = false);
        },
        skrijStolpec: function (e) {
            let column = this.columns.find(c => c.field == e.dataItem.field)
            if (column)
                column.hidden = true;
            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            };
            this.dataResult = process(this.gridData, dataState);

        },
        prikaziStolpec: function (e) {
            let column = this.columns.find(c => c.field == e.dataItem.field)
            if (column)
                column.hidden = false;
            const dataState = {
                skip: this.skip,
                take: this.take,
                filter: this.filter,
                sort: this.sort,
                group: this.group
            };
            this.dataResult = process(this.gridData, dataState);
        },
        nogaNazivVsot: function (h, emptyElement, props, listeners) {

            if (this.dataResult.data) {
                //naredi filter brez paginga...
                const dataState = {
                    filter: this.filter
                };
                let data = process(this.gridData, dataState).data;
                var counts = {};
                for (var i = 0; i < data.length; i++) {
                    counts[data[i]["kmgmid"]] = 1 + (counts[data[i]["kmgmid"]] || 0);
                }
                return h('span', {}, ['Vsota/število unikatnih MID-ov: ' + kendo.toString(Object.keys(counts).length, "n0")]);
            }
            else

                return h('span', {}, ['Vsota/število unikatnih MID-ov:']);
        },
        nogaVsotaKolicina: function () {
            if (this.dataResult.data) {
                const dataState = {
                    filter: this.filter
                };
                let data = process(this.gridData, dataState).data;
                return kendo.toString(data.reduce((acc, current) => acc += current.kolicina, 0), "n2");
            }
        },

        nogaStMidov: function () {
            if (this.dataResult.data) {
                //naredi filter brez paginga...
                const dataState = {
                    filter: this.filter
                };
                let data = process(this.gridData, dataState).data;
                var counts = {};
                for (var i = 0; i < data.length; i++) {
                    counts[data[i]["kmgmid"]] = 1 + (counts[data[i]["kmgmid"]] || 0);
                }
                return 'Vsota/število unikatnih MID-ov: '+ kendo.toString(Object.keys(counts).length, "n0");
               
            }

        },
        formatDate: function (h, emptyElement, props, listeners) {

            return h('td', { attrs: { colspan: 1 } }, [kendo.toString(kendo.parseDate(props.dataItem.veljavnostcertifikataod), 'd')]);
        },



        sezonaChange(event) {
            const sezona = event.value;
            this.dataSezona = sezona;

            this.$router.push({ name: 'proizvodi', params: { sezona: sezona.sezona } })
            this.dataSezona = sezona;
            //this.loadVse(this.dataSezona);



        },


        createAppState: function (dataState) {
            console.log("createAppState");
            this.take = dataState.take;
            this.skip = dataState.skip ? dataState.skip : 0;
            this.group = dataState.group;
            this.filter = dataState.filter;
            this.sort = dataState.sort;

        },

        dataStateChange(event) {
            console.log("DataStateChange");
            console.log(event);
            this.createAppState(event.data);

            this.dataResult = process(this.gridData, {
                skip: this.skip,
                take: this.take,
                sort: this.sort,
                filter: this.filter,
                group: this.group
            });


        },

        exportExcel() {
            this.saveExcel({
                data: process(this.gridData, { sort: this.sort, filter: this.filter }).data,
                fileName: this.dataSezona.sezona + "_PROIZVODI",
                columns: this.columns.filter(i => !i.hidden)
            });
        },


        pageChangeHandler: function (event) {
            console.log(event);
            this.skip = event.page.skip;
            this.take = event.page.take;

        }

    }
};
</script>
